import { render, staticRenderFns } from "./LegendItemCategory.vue?vue&type=template&id=ef676572&"
import script from "./LegendItemCategory.vue?vue&type=script&lang=js&"
export * from "./LegendItemCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports